import qs from "qs";
import axios from "axios";
import { REFRESH_TOKEN, AUTH_TOKEN, USER } from "constants/AuthConstant";
import PermissionManager from "utils/class/PermissionManager";
import moment from "moment";

// Get refresh token
function getRefreshToken() {
	if (typeof window !== "undefined") {
		return PermissionManager.getItem(REFRESH_TOKEN);
	}
}

// Save user tokens
function saveUser(data) {
	if (typeof window !== "undefined") {
		PermissionManager.setItem(AUTH_TOKEN, data.access_token);
		PermissionManager.setItem(REFRESH_TOKEN, data.refresh_token);
	}
}

// Get base URL for analytica API
const getInsightsBaseUrl = () => {
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	return apiBaseUrl.replace("/iorel/api/v1/", "");
};

// Create axios instance for analytica API
const insightsHttp = axios.create({
	baseURL: getInsightsBaseUrl(),
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
		"Access-Control-Allow-Origin": "*",
	},
});

// Request interceptor
insightsHttp.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = `Bearer ${PermissionManager.getItem(AUTH_TOKEN)}`;
		config.headers["tz"] = moment().utcOffset().toString();
		config.headers["Timezone-Offset"] = moment().utcOffset().toString();

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor
insightsHttp.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const originalRequest = error.config;
		const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
		
		if (originalRequest.url !== "/auth/login" && error.response) {
			if (error.response.status === 401 && !originalRequest._retry) {
				originalRequest._retry = true;
				try {
					const refToken = getRefreshToken();
					const data = qs.stringify({
						refresh_token: refToken,
					});

					const config = {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
						},
					};

					const res = await axios.post(`${apiBaseUrl}/auth/mobile/refresh`, data, config);

					saveUser(res?.data);
					insightsHttp.defaults.headers.common["Authorization"] = `Bearer ${PermissionManager.getItem(AUTH_TOKEN)}`;

					return insightsHttp(originalRequest);
				} catch (_error) {
					PermissionManager.removeItem(AUTH_TOKEN);
					PermissionManager.removeItem(REFRESH_TOKEN);
					PermissionManager.removeItem(USER);
					PermissionManager.clear();
					window.location.href = "/";
				}
			}
			return Promise.reject(error);
		}
		return Promise.reject(error);
	}
);

export default insightsHttp;
